import { EQUIPMENT, FEEDERLISTS } from "../_constants/actionConstants";
import _ from "lodash";

const eqInitialState = {
  projEquipLists: {}, // Normalized by projectId,
  openEquipmentDetails: {}, // Normalized by projectId, then equipmentId
  miscSessionData: {}, // Normalized by tabId
  fetching: false,
};

export const reducer = (state = eqInitialState, action) => {
  switch (action.type) {
    case EQUIPMENT.ADD:
    case EQUIPMENT.DELETE:
    case EQUIPMENT.EDIT:
    case EQUIPMENT.FETCH_ALL:
    case EQUIPMENT.FETCH_DETAILS:
    case EQUIPMENT.GENERIC_REQUEST:
      return { ...state, fetching: true };

    case EQUIPMENT.GENERIC_REQUEST_FULFILLED:
    case EQUIPMENT.GENERIC_REQUEST_REJECTED:
      return { ...state, fetching: false };

    case EQUIPMENT.FETCH_DETAILS_FULFILLED: {
      const { projectId, equipmentId, equipmentDetails } = action;
      if (!projectId || !equipmentId || !equipmentDetails)
        return { ...state, fetching: false };

      return {
        ...state,
        fetching: false,
        openEquipmentDetails: {
          ...state.openEquipmentDetails,
          [projectId]: { ...state.openEquipmentDetails, [equipmentId]: equipmentDetails },
        },
      };
    }

    case EQUIPMENT.CLEAR_DETAILS: {
      const { projectId, equipmentId } = action;
      // Return if the details are not currently shown
      if (
        !projectId ||
        !equipmentId ||
        !(projectId in state.openEquipmentDetails) ||
        !(equipmentId in state.openEquipmentDetails[projectId])
      )
        return { ...state, fetching: false };

      // Details exist, proceed to delete
      let openEquipmentDetails = _.cloneDeep(state.openEquipmentDetails);
      delete openEquipmentDetails[projectId][equipmentId];

      return { ...state, fetching: false, openEquipmentDetails };
    }

    case EQUIPMENT.ADD_FULFILLED:
    case EQUIPMENT.DELETE_FULFILLED:
    case EQUIPMENT.FETCH_ALL_FULFILLED:
    case FEEDERLISTS.FETCH_FULFILLED: {
      const { projectId, projEquipList } = action;
      if (!projectId || !projEquipList) return { ...state, fetching: false };

      return {
        ...state,
        fetching: false,
        projEquipLists: {
          ...state.projEquipLists,
          [projectId]: projEquipList,
        },
      };
    }

    case EQUIPMENT.EDIT_FULFILLED: {
      const { projectId, equipmentId, equipmentDetails } = action;
      if (!projectId || !equipmentId || !equipmentDetails)
        return { ...state, fetching: false };

      return {
        ...state,
        fetching: false,
        openEquipmentDetails: {
          ...state.openEquipmentDetails,
          [projectId]: {
            ...state.openEquipmentDetails[projectId],
            [equipmentId]: equipmentDetails,
          },
        },
      };
    }

    default:
      return state;
  }
};
